import { getElectronAPI } from "@org-avp/avp-avengers-ui-framework-electron-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { AllCommunityModule, AllEnterpriseModule, LicenseManager, ModuleRegistry } from "ag-grid-enterprise";

// side effect: register all AG grid modules
ModuleRegistry.registerModules([
  AllEnterpriseModule,
  AllCommunityModule,
]);

// side effect: set AG Grid license key
LicenseManager.setLicenseKey(environment.NX_AGGRID_LICENSE_KEY);

// Setup IPC listener for console logs from main thread
getElectronAPI()?.on.messageFromMain((_, text) => {
  console.log(`[Electron main] ${text}`);
});

// exports for webapp module, consisting only of two calls
export { registerAllViews } from "./app/modules";
export { renderAppShell } from "./render";
